import { Suspense } from 'react';
import { Toaster } from 'react-hot-toast';
import { AppProvider } from '@/providers/app-provider';
import { SplashScreen } from './components/splash-screen';
import { AppRoutes } from './routes';

function App() {
  return (
    <div className="min-h-screen w-full bg-surface-base">
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#171717',
            color: '#FFFFFF',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#E2FD70',
              secondary: '#1A1A1A',
            },
          },
          error: {
            iconTheme: {
              primary: '#FF6B6B',
              secondary: '#FFFFFF',
            },
          },
        }}
      />
      <AppProvider>
        <Suspense fallback={<SplashScreen />}>
          <AppRoutes />
        </Suspense>
      </AppProvider>
    </div>
  );
}

export default App;
